import React from 'react';
//import { ListItem } from 'material-ui/List';
import ListItem from '@material-ui/core/ListItem';
import moment from 'moment';
import {TIME_DATE_FORMAT } from '../../constants';

const InboxListItemValidation = (props) => {
  const { 
    specimen, 
    isSelected, 
    specimenArray,
  } = props;

  const arrayIndex = specimenArray.map(spec => spec._id.toString()).indexOf(specimen._id.toString()) +1;

  return (
    <ListItem
      button
      selected={isSelected}
      classes={{ root: 'validation__sidebar__item', selected: 'is-selected' }}
      onClick={() => {
        props.handleSpecimenSelected(specimen);
        props.handleCollapse();
      }}
    >

      <div className="validation__sidebar__item-text-container">Specimen {arrayIndex}</div>
      <div className="sidebar__item-subtitle">
        { specimen.analyses[0].analysisUpdatedAt ? moment(specimen.analyses[0].analysisUpdatedAt).format(TIME_DATE_FORMAT) : '' }
      </div>

    </ListItem>
  );
};

export default InboxListItemValidation;
